import styled from "styled-components";
import { getThemeColor, MAIN_DARK, WHITE_e4e4e4 } from "constants/colors";

export const PlainSelectShadowWrapper = styled.div<{
  withoutTheme?: boolean;
  isStrategy?: boolean;
}>`
  border-radius: 8px;
  // border: 1px solid var(--border-strength-100, #e3e3e3);
  background: var(--cointr-color-fill2, #fff);
  box-shadow: 0 10px 32px 0 rgba(31, 31, 31, 0.15);
`;

export const PlainSelectWrapper = styled.ul<{
  withoutTheme?: boolean;
  isStrategy?: boolean;
  showSearch?: boolean;
}>`
  padding: 12px 0px;

  padding-top: ${(props) =>
    props?.isStrategy && props?.showSearch ? "54px" : "12px"};
  border-radius: 8px;

  > li {
    color: var(--content-primary, #1f1f1f);
    cursor: pointer;
    font-size: 12px;
    line-height: 18px;
    padding: 10px 16px;
    // margin-bottom: 4px;
    white-space: nowrap;
    &:hover,
    &.active {
      background: var(--cointr-color-line2);
      > a {
        color: var(--content-primary, #1f1f1f);
      }
      color: var(--cointr-color-success1);
    }

    > a {
      color: var(--minor-grey-text);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
export const PlainSelectShadowWrapperForStrategy = styled.div<{
  withoutTheme?: boolean;
}>``;
// export const PlainSelectShadowWrapperForStrategy = styled.div<{ withoutTheme?: boolean }>`
//     box-shadow: 0 0 5px 0
//         ${props => (props.withoutTheme ? WHITE_e4e4e4 : getThemeColor('language_boxshadow'))};
//     border: 1px solid var(--color-line);
// `

export const PlainSelectWrapperForStrategy = styled.ul<{
  withoutTheme?: boolean;
}>`
  padding: 5px 8px;

  background: var(--color-sk);

  box-shadow: 0 0 5px 0
    ${(props) =>
      props.withoutTheme ? WHITE_e4e4e4 : getThemeColor("language_boxshadow")};

  border-radius: 6px;

  li {
    border-radius: 2px;
    color: ${(props) =>
      props.withoutTheme ? MAIN_DARK : getThemeColor("text_white_5")};
    cursor: pointer;
    font-size: 14px;
    line-height: 14px;
    padding: 8px 8px;
    margin-bottom: 4px;
  }
`;
